import React from 'react';

const ErrorPage = () => {
	const bgImage = 'https://viewiq-ui-assets.s3.amazonaws.com/errorpage-bg.png';
	return <div
		className='error-page'
		style={{
			backgroundImage: `url(${bgImage})`,
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			height: '100%',
			width: '100%',
			position: 'fixed',
			top: 0,
			left: 0,
			zIndex: 9999
		}}
	>
		<div className='message-text'>
			<span className='header'>Sorry!</span>
			<span className='main'>
				Your request can't be completed at the moment.
				<br />
				Please try again soon.
			</span>
		</div>
	</div>;
}

export default ErrorPage;
